import { differenceInCalendarDays, parse } from "date-fns";
import { OptionsWithTZ, formatInTimeZone } from "date-fns-tz";
import { enUS, fr, nl, es, de } from "date-fns/locale";

import { Locale } from "@/i18n/types";

const dateFnsLocales = {
  en: enUS,
  fr,
  nl,
  es,
  de,
};

export const getDateFnsLocale = (locale: Locale) => dateFnsLocales[locale];

function getDaysUntil(date: Date): number {
  const now = new Date();
  return differenceInCalendarDays(date, now);
}

function getDate(input: string): Date {
  return new Date(input);
}

function format(
  date: string | Date,
  dateFormat: string,
  timeZone?: string,
  options?: OptionsWithTZ | undefined
) {
  return formatInTimeZone(
    new Date(date),
    timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
    dateFormat,
    options
  );
}

function getDateFromYYYYMMDD(yyyymmdd: string) {
  // problem: when doing new Date('2023-05-31'), because js does not see a timezone, it will assume the date is UTC

  // the `parse` function will parse the date in the current timezone
  // thanks to the 3rd argument `new Date()` (that it will use the get the missing informations, so the timezone)
  return parse(yyyymmdd, "yyyy-MM-dd", new Date());
}

function formatDateFromYYYYMMDD(
  yyyymmdd: string,
  dateFormat: string,
  options?: OptionsWithTZ | undefined
) {
  // problem: when doing new Date('2023-05-31'), because js does not see a timezone, it will assume the date is UTC
  // so when formating the date, if the user's browser in EST for example, we will display May, 30, 2023 instead of May, 31, 2023
  // because 00:00 the 31st in UTC is 20:00 the 30th in EST
  // --> this function will force the date to be in the current timezone, displaying the same date for all timezone, ie. May, 31, 2023

  const date = getDateFromYYYYMMDD(yyyymmdd);

  return format(date, dateFormat, undefined, options);
}

export {
  getDaysUntil,
  getDate,
  formatDateFromYYYYMMDD,
  getDateFromYYYYMMDD,
  format,
};
